import { useState } from 'react';
import { FaEyeSlash } from 'react-icons/fa';
import HideRowsAndColsModal from './HideRowsAndColsModal';

const HideRowsAndCols = ({ sheetId }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <div
                className="relative group flex items-center gap-1 sm:gap-2 px-2 sm:px-3  py-1 bg-white hover:bg-gray-50 border-2 border-gray-800 rounded-lg shadow-lg cursor-pointer transition-all duration-200 hover:shadow-xl"
                onClick={() => setShowModal(true)}
                onMouseEnter={(e) => {
                    const tooltip = e.currentTarget.querySelector('.hide-tooltip');
                    if (tooltip) tooltip.style.opacity = '1';
                }}
                onMouseLeave={(e) => {
                    const tooltip = e.currentTarget.querySelector('.hide-tooltip');
                    if (tooltip) tooltip.style.opacity = '0';
                }}
            >
                <FaEyeSlash size={15} className="text-gray-700 sm:w-[20px] sm:h-[20px]" />
                <span className="font-medium text-gray-800 text-sm sm:text-base xs:inline">Hide</span>
                <div
                    className="hide-tooltip mt-2 z-[10000] absolute top-full left-1/2 mb-2 px-3 py-1.5 bg-gray-900 text-white text-xs rounded-md whitespace-nowrap pointer-events-none transition-opacity duration-200"
                    style={{
                        transform: 'translateX(-50%)',
                        opacity: 0,
                    }}
                >
                    Hide Rows & Cols
                    <div
                        className="absolute bottom-full left-1/2 border-4 border-transparent border-b-gray-900"
                        style={{ transform: 'translateX(-50%)', marginBottom: '-8px' }}
                    ></div>
                </div>
            </div>

            <HideRowsAndColsModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                sheetId={sheetId}
            />
        </>
    );
};

export default HideRowsAndCols;
